<template>
  <v-dialog v-model="dialog" width="500">
    <template v-slot:activator="{ on, attrs }">
      <v-tooltip bottom v-bind="attrs" v-on="on">
        <template v-slot:activator="{ on }">
          <span v-on="on">
            <v-btn x-small text @click.stop="openDialog"
              ><v-icon small>mdi-pencil</v-icon></v-btn
            >
          </span>
        </template>
        <span> Edit </span>
      </v-tooltip>
    </template>

    <v-card class="primary--text" v-if="dialog">
      <validation-observer ref="form" v-slot="{ invalid }">
        <v-card-title> Edit Assessment </v-card-title>
        <v-card-text class="pt-0">
          <validation-provider :rules="{ required: true }" v-slot="{ errors }">
            <v-select
              v-model="form.aarLocation"
              prepend-icon="mdi-map-marker"
              label="AAR Location"
              :items="aarLocations"
              :error-messages="errors"
            ></v-select>
            <date-picker
              :field="{ label: 'Date of Service' }"
              :value="form.dateOfService"
              :validations="{ required: true }"
              @fieldChange="form.dateOfService = $event"
            >
            </date-picker>
          </validation-provider>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :dark="!loading"
            :disabled="loading"
            text
            @click="clear"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            :dark="!loading && !invalid"
            :disabled="loading || invalid"
            text
            @click.once="save"
            >Save</v-btn
          >
        </v-card-actions>
      </validation-observer>
    </v-card>
  </v-dialog>
</template>

<script>
import AARAssessment from "../../objs/AARAssessment";
export default {
  props: ["assessment"],
  data() {
    return {
      dialog: false,
      loading: false,
      form: new AARAssessment(),
    };
  },
  computed: {
    aarLocations: function () {
      return this.$store.state.optionsModule.aarLocations;
    },
  },
  methods: {
    openDialog() {
      this.dialog = true;
      this.form = { ...this.assessment };
      this.form.dateOfService = new Date(this.assessment.dateOfService);
    },
    async save() {
      this.loading = true;
      var success = await this.$store.dispatch(
        "assessmentsModule/updateAARAssessment",
        this.form
      );
      this.clear();
      this.loading = false;
      if (!success) {
        this.$store.commit("uxModule/setSnackbarMsg", "Error saving changes.");
        this.$store.commit("uxModule/setShowSnackbar", true);
      }
    },
    clear() {
      this.dialog = false;
    },
  },
};
</script>
